<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <rect x="11" y="4" width="3" height="17" fill="currentColor" />
    <rect x="21" y="11" width="3" height="17" transform="rotate(90 21 11)" fill="currentColor" />
  </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
